import React, { useEffect } from "react"
import { Title } from "../../services/page-title/Title"
import { MasterLayout } from "../views/atoms/layouts/MasterLayout"
import { FlexContainer, Body, TextLink, Button, Stack } from "@carrotfertility/carotene"
import { RetinaImage } from "../views/atoms/images/RetinaImage"
import { useHistory } from "react-router"
import { useCurrentUser } from "../context/user/UserContext"

export default function CarrotPlanRequiredPage(): JSX.Element {
  const { isInAppLockdown } = useCurrentUser()
  const history = useHistory()
  useEffect(() => {
    if (!isInAppLockdown) {
      history.push("/")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See https://carrotfertility.atlassian.net/wiki/spaces/PE/pages/2050295461/Remove+Build+Warnings#react-hooks%2Fexhaustive-deps
  }, [isInAppLockdown])

  function handleReturnHome(): void {
    history.push("/")
  }
  function handleGetCarrotPlan(): void {
    history.push("/carrot-plans/about-you")
  }
  return (
    <>
      <Title title="Carrot Plan required" />
      <MasterLayout header={null}>
        <FlexContainer justifyContent="center" alignItems="center" width="100%" height={["100%", null, "100vh"]}>
          <FlexContainer
            borderRadius="8px"
            background="pampas"
            padding="giant"
            justifyContent="flex-start"
            alignItems="center"
            direction="column"
          >
            <FlexContainer stack="tiny" justifyContent="center">
              <RetinaImage name="illo-underwater-desktop" width={214} height={162} />
            </FlexContainer>
            <Stack
              sx={{ textAlign: "center" }}
              stack="small"
              spacing="4px"
              justifyContent="center"
              alignItems="center"
              direction="column"
            >
              <Body color="black80">To access this page, get your Carrot Plan.</Body>
              <TextLink href="/your-benefit-guide/about-your-benefit">Learn about Carrot Plans</TextLink>
            </Stack>
            <Stack direction={["column", null, "row"]} alignItems="center" spacing="tiny" justifyContent="center">
              <Button variant="secondary" onClick={handleReturnHome}>
                Return home
              </Button>
              <Button variant="primary" onClick={handleGetCarrotPlan}>
                Get Carrot Plan
              </Button>
            </Stack>
          </FlexContainer>
        </FlexContainer>
      </MasterLayout>
    </>
  )
}
